import { apiClient } from '../client'

export interface AttackSurfaceData {
  data: {
    domains?: {
      hosts_count: number | null
      ipv4s_count: number | null
      ports_count: number | null
      total_vuln: number | null
    }
    ip?: {
      ip_count: number | null
      ports_count: number | null
      total_vuln: number | null
    }
    ports?: {
      ports_count: number | null
      closed_ports: number | null
      open_ports: number | null
    }
    techs?: {
      techs_count: number | null
    }
    dns_records?: {
      total: number | null
      A: number | null
      CNAME: number | null
    }
    ssl?: {
      ssl_count: number | null
      expiring_ssl_count: number | null
    }
    email?: {
      email_count: number | null
    }
    leaked_data?: {
      total: number | null
    }
  }
  message?: string
  detail?: string
}

/**
 * Attack Surface API endpoints
 */
export const attackSurfaceApi = {
  /**
   * Get attack surface overview data
   */
  getData: async (params?: string): Promise<AttackSurfaceData> => {
    const url = params ? `/attack-surface/${params}` : '/attack-surface/'
    const { data } = await apiClient.get(url)
    return { data }
  },
}
